export default {
    parts: [
        'container',
        'content',
        'description',
        'swatchesWrapper',
        'swatchImage',
        'footer',
        'continueButton'
    ],
    baseStyle: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100dvh - 65px)'
        },
        content: {
            flex: '1',
            p: '24px 16px'
        },
        description: {
            textStyle: 'bodySmRegular',
            mb: '22px'
        },
        swatchesWrapper: {
            display: 'flex',
            flexDirection: 'column',
            gap: '22px'
        },
        swatchImage: {
            height: '100%',
            width: '100%',
            minWidth: '32px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        },
        footer: {
            p: 4,
            borderTop: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        },
        continueButton: {
            width: '100%'
        }
    }
}
